/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./DoctorRequestListDialog.vue?vue&type=template&id=c4d2b6f6"
import script from "./DoctorRequestListDialog.vue?vue&type=script&lang=js"
export * from "./DoctorRequestListDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4d2b6f6')) {
      api.createRecord('c4d2b6f6', component.options)
    } else {
      api.reload('c4d2b6f6', component.options)
    }
    module.hot.accept("./DoctorRequestListDialog.vue?vue&type=template&id=c4d2b6f6", function () {
      api.rerender('c4d2b6f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/DoctorRequestListDialog.vue"
export default component.exports